export const SHAREHOLDERS_MODAL_COUNTRY_CL = 'CL';
export const SHAREHOLDERS_MODAL_COUNTRY_CO = 'CO';

export const SHAREHOLDERS_MODAL_EXCLUDED_COUNTRIES = ['CO'];

/**
 * Empresas exentas del flujo de beneficiarios finales (modal + bloqueo de navegación).
 * Se usa para cuentas operativas internas (ej. tesorería) que no deben ser interrumpidas
 * por el proceso de declaración, independientemente de su país o tipo de wallet.
 */
export const SHAREHOLDERS_MODAL_WHITELISTED_COMPANY_IDS = ['2305598', '813508'];

export const SHAREHOLDERS_VERIFICATION_ERROR_MESSAGE =
  'No pudimos verificar tu declaración de beneficiarios finales. Intenta nuevamente en unos minutos.';
